import { createActions } from 'redux-actions';

export const { setCustomers } = createActions('SET_CUSTOMERS');
